import React, { forwardRef } from 'react';
import { getMonth, getYear, isEqual, isFuture, isPast, isSameDay, isToday } from 'date-fns';
import { useUIDSeed } from 'react-uid';
import { Flex, Icon, Text } from '..';
import { WeekDays } from './weekDays';
import styles from './date-picker.module.css';
import { useCalendarManager } from './useCalendarManager';
export const Calendar = forwardRef(({ title, visible, disableFuture, disablePast, disabledDates }, forwardedRef) => {
    const { format, internalCalendarDate, months, setDate, locale, userSelectedDate } = useCalendarManager();
    const seed = useUIDSeed();
    const formatCurrentMonth = format(internalCalendarDate, 'MMM yyyy');
    const defaultTitle = locale === 'en' ? 'Select a date' : 'Seleziona una data';
    if (!visible)
        return null;
    const disableNavigationToPast = disablePast && (getYear(new Date()) >= getYear(internalCalendarDate)) && (getMonth(new Date()) >= getMonth(internalCalendarDate));
    return (React.createElement(Flex, { rowGap: 16, className: styles.calendar, horizontalAlign: 'center', verticalAlign: 'start', ref: forwardedRef },
        React.createElement(Text, { size: 16, color: 'black', className: styles.title }, title || defaultTitle),
        React.createElement(Flex, { className: styles.navigationHeader, direction: 'row', horizontalAlign: 'space-between', verticalAlign: 'center' },
            React.createElement("button", { type: "button", "data-nav-disabled": disableNavigationToPast, className: styles.navigation, onClick: () => { if (!disableNavigationToPast)
                    months.previous(); } },
                React.createElement(Icon, { className: styles.navigationIcon, name: 'arrow-left/16' })),
            React.createElement(Text, null, formatCurrentMonth),
            React.createElement("button", { type: "button", "data-nav-disabled": disableFuture, className: styles.navigation, onClick: () => { if (!disableFuture)
                    months.next(); } },
                React.createElement(Icon, { className: styles.navigationIcon, name: 'arrow-right/16' }))),
        React.createElement(Flex, { rowGap: 8, className: styles.monthContainer },
            React.createElement("div", { className: styles.grid },
                React.createElement(WeekDays, null)),
            months.get().map((week) => (React.createElement("div", { key: seed(week), className: styles.grid, tabIndex: 0, role: 'grid', "aria-label": 'Month' }, week.map((day, i) => {
                if (day) {
                    const active = isEqual(userSelectedDate, day);
                    const disabledDate = disabledDates === null || disabledDates === void 0 ? void 0 : disabledDates.some((excludeDate) => isSameDay(day, excludeDate));
                    const disabled = (disableFuture && isFuture(day))
                        || (disablePast && isPast(day) && !isToday(day))
                        || disabledDate;
                    const selectDay = () => setDate(day);
                    const handleKeyPress = (e) => {
                        if (e.key === 'Enter' || e.key === 'Space')
                            selectDay();
                    };
                    return (React.createElement("button", { type: 'button', onClick: selectDay, onKeyPress: handleKeyPress, className: styles.day, "data-day-disabled": disabled, "data-day-active": active, disabled: disabled, "aria-selected": active, role: 'gridcell', key: seed(day) },
                        React.createElement(Text, { className: styles.dayText, size: 14, textAlign: 'center' }, format(new Date(day), 'dd'))));
                }
                return React.createElement("div", { key: seed(`empty-month-week-${i}`) });
            })))))));
});
